import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Divider, Checkbox, Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { isEmpty, find } from 'lodash';

import RightsCompanyTree from './RightsCompanyTree';
import * as constants from '../constants';
import {
    updateSelectedLocalUserRoleActive,
    updateSelectedLocalUserRoleGlobal,
    updateSelectedLocalSecurableEntityCompany,
    saveSelectedUserRoleDetails,
    reloadAppRolesForCurrentUser,
    updateSelectedLocalSecurableEntityCompanyInherit
} from '../actions';

import companies from '../../companies';
import uistate from '../../uistate';
import common from '../../../common';

class LocalUserRoleDetailsCompanies extends Component {

    state = {
        selectedSecurableEntity: 0,
        selectedSecurableEntityName: ''
    }
    onChangeRoleActive = (e) => {
        this.props.updateSelectedLocalUserRoleActive(e.target.checked);
    }
    onChangeRoleGlobal = (e) => {
        this.props.updateSelectedLocalUserRoleGlobal(e.target.checked);
    }
    onChangeRoleInherit = (e) => {
        if (this.state.selectedSecurableEntity > 0) {
            this.props.updateSelectedLocalSecurableEntityCompanyInherit(e.target.checked, this.state.selectedSecurableEntity);
            //console.log('inherit:', e.target.checked)
        }
    }
    onCheckSecurableEntityChanged = (idCompany, checked) => {
        this.props.updateSelectedLocalSecurableEntityCompany(checked, idCompany);
        //console.log('tv-checked', idCompany, checked);
    }
    onSelectedSecurableEntityChanged = (idCompany) => {
        //console.log('tv-selected', idCompany);
        const currentCompany = find(this.props.companies, ['idCompany', idCompany]);
        this.setState({
            selectedSecurableEntity: idCompany,
            selectedSecurableEntityName: ` (${currentCompany.name})`
        });
    }

    onSave = async () => {
        await this.props.saveSelectedUserRoleDetails()
        this.props.reloadAppRolesForCurrentUser();
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'LocalUserRoleDetailsCompanies', key);
    }

    render() {
        let emptyRoleDetails = isEmpty(this.props.userRoleDetails);
        let inheritChecked = false;
        if (!emptyRoleDetails) {
            const currentSecurableEntity = find(this.props.userRoleDetails.securableEntities, ['entityId', this.state.selectedSecurableEntity]);
            if (currentSecurableEntity) {
                inheritChecked = currentSecurableEntity['inherit']
            }
        }
        return (
            <div>
                {!emptyRoleDetails &&
                    <div className='userrole-details'>
                        <Divider orientation="left">{this.label("RoleDetails")} {this.props.userRoleDetails.userRole.roleName}</Divider>
                        <div style={{ margin: 7 }}>
                            <Checkbox checked={this.props.userRoleDetails.userRole.active} onChange={this.onChangeRoleActive}>Active</Checkbox>
                            <br />
                            {this.props.userRoleDetails.userRole.active &&
                                <div>
                                    <Checkbox checked={this.props.userRoleDetails.userRole.isGlobalRole} onChange={this.onChangeRoleGlobal}>Global</Checkbox>
                                    <br />
                                    <Checkbox checked={inheritChecked} onChange={this.onChangeRoleInherit}>{this.label("Inherit")}{this.state.selectedSecurableEntityName}</Checkbox>
                                    <br />
                                    <Divider orientation="left">{this.label("Companies")}</Divider>
                                    <div className='selectedRoleRights'>
                                        <Button style={{ marginTop: 20 }} type="primary" icon={<SaveOutlined />} onClick={this.onSave} >{this.label("Save")}</Button>
                                        <RightsCompanyTree
                                            companies={this.props.companies}
                                            roledetails={this.props.userRoleDetails}
                                            onChecked={this.onCheckSecurableEntityChanged}
                                            onSelected={this.onSelectedSecurableEntityChanged} />
                                    </div>
                                </div>
                            }

                        </div>
                    </div>
                }
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        userRoleDetails: state[constants.NAME].selectedUserRoleDetails,
        companies: companies.selectors.allCompanies(state),
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps, {
    updateSelectedLocalUserRoleActive,
    updateSelectedLocalUserRoleGlobal,
    updateSelectedLocalSecurableEntityCompany,
    saveSelectedUserRoleDetails,
    reloadAppRolesForCurrentUser,
    updateSelectedLocalSecurableEntityCompanyInherit
})(LocalUserRoleDetailsCompanies);